import { SpinnerCenter, useRemoteConfig } from "@shapr3d/frontend-lib";

import { IntentPage } from "../components/IntentPage/IntentPage";
import SegmentationSurvey from "../components/SegmentationSurvey/SegmentationSurvey";
import UnderMaintenanceOrChildren from "../components/UnderMaintenanceOrChildren/UnderMaintenanceOrChildren";

const SegmentationSurveyPage = () => {
  const intentPageVariant = useRemoteConfig("web_intent_page-cd");

  if (intentPageVariant === undefined) {
    return <SpinnerCenter />;
  }

  if (intentPageVariant === "treatment") {
    return <IntentPage />;
  }

  return (
    <UnderMaintenanceOrChildren>
      <SegmentationSurvey />
    </UnderMaintenanceOrChildren>
  );
};

export default SegmentationSurveyPage;
